import { ApiUrlEditor } from './src/ApiUrlEditor.js';
window.customElements.define('api-url-editor', ApiUrlEditor);
